export const authTexts = {
  et: {
    username: "Kasutajanimi",
    email: "E-post",
    password: "Parool",
    confirmPassword: "Kinnita parool",

    register: "Registreeru",
    signIn: "Logi sisse",
    login: "Sisselogimine",
    enterusername: "Sisesta kasutajanimi",
    enteremail: "Sisesta e-post",
    enterpassword: "Sisesta parool",

    remember: "Jäta mind meelde",
    haveAccount: "Kas sul on juba konto?",
    registerHere: "Registreeru siin",
    noAccount: "Pole veel kontot?",
    signInHere: "Logi sisse siin",
    loginFailed: "Sisselogimine ebaõnnestus. Palun kontrolli kasutajanime ja parooli.",
    accountNotActivated: "Konto pole veel aktiveeritud. Saatsime aktiveerimise e-kirja uuesti sinu postkasti — palun kontrolli ka rämpsposti kausta.",
    forgotPassword: "Unustasid parooli?",
    registerSuccess: "Konto loodud!",
    usernameOrEmail: "Kasutajanimi või e-post",
    orDivider: "või",
    invalidEmail: "Vigane e-posti aadress.",
    googleSignIn: "Logi sisse Google'iga",
    sharedAccountHint: "Sama konto töötab ka akordion.ee poes.",
  },

  en: {
    username: "Username",
    email: "Email",
    password: "Password",

    register: "Register",
    signIn: "Sign in",
    login: "Login",
    enterusername: "Enter your username",
    enteremail: "Enter your email",
    enterpassword: "Enter your password",
    confirmPassword: "Confirm password",

    remember: "Remember me",
    haveAccount: "Already have an account?",
    registerHere: "Register here",
    noAccount: "No account yet?",
    signInHere: "Sign in here",
    loginFailed: "Failed to log in. Please check your username and password.",
    accountNotActivated: "Your account isn't activated yet. We've resent the activation email to your inbox — please check your spam folder too.",
    forgotPassword: "Forgot your password?",
    registerSuccess: "Account created!",
    usernameOrEmail: "Username or email",
    orDivider: "or",
    invalidEmail: "Invalid email address.",
    googleSignIn: "Sign in with Google",
    sharedAccountHint: "The same account also works in the akordion.ee shop.",
  },
};